var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bed_box"},_vm._l((_vm.bed_list),function(item,index){return _c('div',{key:index,staticClass:"bed",on:{"click":function($event){return _vm.bedDetail(index+300)}}},[_c('div',[_vm._v(_vm._s(index + 300)+"床")]),_vm._v(" "),_c('div',[_vm._v("xxx 女 33岁")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c67e6b90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/bed_list.vue
// module id = null
// module chunks = 